<template>
    <div class="yelp-stars">
        <div class="yelp-stars__rating">
            {{ stars }}
        </div>

        <div class="yelp-stars__stars">
            <div
                v-for="i in 5"
                :key="i"
                class="yelp-stars__star"
            >
                <!-- Show full star -->
                <svg
                    v-if="i <= stars"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 18 18"
                >
                    <rect
                        class='yelp-stars__star-inner'
                        x="1"
                        y="1"
                        width="16"
                        height="16"
                        fill="rgba(255, 255, 255, 0)"
                    />
                    <path
                        fill="#f02733"
                        d="M15.96,0H2.03C0.91,0,0,0.9,0,2.03v13.93C0,17.09,0.91,18,2.03,18h13.93c1.13,0,2.04-0.91,2.04-2.04V2.03C18,0.9,17.09,0,15.96,0z M13.29,15.61L9,12.48l-4.3,3.13l1.65-5.06L2.04,7.43l5.32,0.01L9,2.38l1.63,5.06l5.32-0.01l-4.31,3.12L13.29,15.61z"
                    />
                </svg>

                <!-- Show partially filled star -->
                <svg
                    v-else-if="Math.ceil(stars) === i && stars % 1 > 0"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 18 18"
                >
                    <rect
                        class='yelp-stars__star-inner'
                        x="1"
                        y="1"
                        width="16"
                        height="16"
                        fill="rgba(255, 255, 255, 0)"
                    />
                    <path
                        fill="#d5d5d4"
                        d="M15.96,0H2.03C0.91,0,0,0.9,0,2.03v13.93C0,17.09,0.91,18,2.03,18h13.93c1.13,0,2.04-0.91,2.04-2.04V2.03C18,0.9,17.09,0,15.96,0z M13.29,15.61L9,12.48l-4.3,3.13l1.65-5.06L2.04,7.43l5.32,0.01L9,2.38l1.63,5.06l5.32-0.01l-4.31,3.12L13.29,15.61z"
                    />
                    <path
                        :style="{'clip-path': getClipPath}"
                        fill="#f02733"
                        d="M15.96,0H2.03C0.91,0,0,0.9,0,2.03v13.93C0,17.09,0.91,18,2.03,18h13.93c1.13,0,2.04-0.91,2.04-2.04V2.03C18,0.9,17.09,0,15.96,0z M13.29,15.61L9,12.48l-4.3,3.13l1.65-5.06L2.04,7.43l5.32,0.01L9,2.38l1.63,5.06l5.32-0.01l-4.31,3.12L13.29,15.61z"
                    />
                </svg>

                <!-- Show empty star -->
                <svg
                    v-else
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 18 18"
                >
                    <rect
                        class='yelp-stars__star-inner'
                        x="1"
                        y="1"
                        width="16"
                        height="16"
                        fill="rgba(255, 255, 255, 0)"
                    />
                    <path
                        fill="#d5d5d4"
                        d="M15.96,0H2.03C0.91,0,0,0.9,0,2.03v13.93C0,17.09,0.91,18,2.03,18h13.93c1.13,0,2.04-0.91,2.04-2.04V2.03C18,0.9,17.09,0,15.96,0z M13.29,15.61L9,12.48l-4.3,3.13l1.65-5.06L2.04,7.43l5.32,0.01L9,2.38l1.63,5.06l5.32-0.01l-4.31,3.12L13.29,15.61z"
                    />
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        stars: {
            type: Number,
            required: true,
        },
    },

    computed: {
        getClipPath() {
            const percentage = this.stars % 1 * 100 + '%';
            return `polygon(0 0, ${percentage} 0, ${percentage} 100%, 0 100%)`;
        },
    },
};
</script>

<style lang="scss">
@import "zoe-atom-yelp-stars";
</style>
